import { ConfigService } from '@stockcare-services/config-service/config.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITheme } from '@stockcare-models/ITheme';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { Settings } from '@stockcare-helpers/settings';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(private http: HttpClient, private settingsService: SettingsService, private configurationService: ConfigService) {}

  initialize() {
    console.log('Starting theme service');
    this.setTheme();
    this.getActiveTheme();
  }

  private getActiveTheme() {
    this.http.get<ITheme>(`${this.configurationService.config.baseUrl}/themes/theme`).subscribe((activeTheme) => {
      localStorage.setItem('theme', JSON.stringify(activeTheme));
      this.setTheme();
    });
  }

  getTheme(): ITheme {
    return JSON.parse(localStorage.getItem('theme'));
  }

  setTheme() {
    const theme = JSON.parse(localStorage.getItem('theme'));

    if (theme == null) {
      return;
    }

    this.setThemeProperty('--primary', theme.primary);
    this.setThemeProperty('--secondary', theme.secondary);
    this.setThemeProperty('--tertiary', theme.tertiary);
    this.setThemeProperty('--dark-grey', theme.darkGrey);
    this.setThemeProperty('--medium-grey', theme.mediumGrey);
    this.setThemeProperty('--light-grey', theme.lightGrey);
    this.setThemeProperty('--blue-grey', theme.blueGrey);
    this.setThemeProperty('--white', theme.white);
    this.setThemeProperty('--positive', theme.positive);
    this.setThemeProperty('--negative', theme.negative);
    this.setThemeProperty('--input-grey', theme.inputGrey);
    this.setThemeProperty('--toast', theme.toast);
    this.setThemeProperty('--medium-grey-rgb', theme.mediumGreyRgb);
    this.setThemeProperty('--light-grey-rgb', theme.lightGreyRgb);
    this.setThemeProperty('--white-rgb', theme.whiteRgb);
    this.setThemeProperty('--border-color', theme.borderColor);
  }

  private setThemeProperty(name, value) {
    document.body.style.setProperty(name, value);
  }
}
